import type { PropsWithChildren } from 'react';

import ContentLoader from './ContentLoader';
import NoData from './NoData';

interface Props {
    height?: string;
    isLoading?: boolean;
    isMissing?: boolean;
}

const RequestedValue = ({ children, height, isLoading, isMissing }: PropsWithChildren<Props>) => {
    if (isLoading) {
        return <ContentLoader data-testid='requested-value-loader' height={height ?? '16px'} width='50%' />;
    }

    if (isMissing) {
        return <NoData data-testid='requested-value-no-data' text='No data' className='text-16' />;
    }

    return children;
};

export default RequestedValue;
